import Http from "@/commons/Http";
import Utils from "@/utils/Utils";

const path = 'api/client';

const genders = [
    {id: 'MASCULINE', name: 'forms.client.masculine'},
    {id: 'FEMININE', name: 'forms.client.feminine'},
    {id: 'OTHER', name: 'forms.client.other'},
];

const maritalStatus = [
    {id: 'SINGLE', name: 'forms.client.single'},
    {id: 'MARRIED', name: 'forms.client.married'},
    {id: 'STABLE_UNION', name: 'forms.client.stable_union'},
    {id: 'DIVORCED', name: 'forms.client.divorced'},
    {id: 'WIDOWED', name: 'forms.client.widowed'},
];

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async search(name){
        if(Utils.isEmptyNullOrUndefined(name)) {
            return null;
        }
        return Http.get(`${path}/s/10?name=${name}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Client"};
        return Http.post(`${path}/audit?sort=${sort || 'a.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'c.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    getTypeOfPerson() {
        return [
            {id: 'PERSON', name: 'forms.client.singlePerson'},
            {id: 'COMPANY', name: 'forms.client.companyPerson'},
        ]
    },

    getGenders() {
        return genders
    },

    getGenderLabel(genderId){
        let genderLabel = "";
        genders.forEach(gender => {
           if(gender.id === genderId){
               genderLabel = gender.name;
           }
        });
        return genderLabel;
    },

    getMaritalStatus() {
        return maritalStatus;
    },

    getMaritalStatusLabel(maritalStatusId){
        let maritalStatusLabel = "";
        maritalStatus.forEach(maritalStatus => {
           if(maritalStatus.id === maritalStatusId){
            maritalStatusLabel = maritalStatus.name;
           }
        });
        return maritalStatusLabel;
    },

}
